import {
  MARKETING_MERCHANTS_HOME_STORES_GET_SUCCESS,
  MARKETING_MERCHANTS_HOME_STORES_GET_FAILURE,
} from '../actions/types';
import config from '../configs';

const { merchantsConfig } = config;

const initialState = {
  config: merchantsConfig,
  merchants: [],
  isLoading: false,
  isLoaded: false,
};

const marketingMerchantsHomeStores = (state = initialState, action) => {
  switch (action.type) {
    case MARKETING_MERCHANTS_HOME_STORES_GET_SUCCESS: {
      const placements = action.payload.response;
      const merchants = placements.map(placement => placement.merchant);
      return {
        ...state,
        merchants,
        isLoading: false,
        isLoaded: true,
      };
    }
    case MARKETING_MERCHANTS_HOME_STORES_GET_FAILURE: {
      return {
        ...state,
        merchants: [],
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === MARKETING_MERCHANTS_HOME_STORES_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default marketingMerchantsHomeStores;
